import { Paragraph } from "../elements/Paragraph";
import { CardTextRadio } from "./CardTextRadio";
import * as styles from "./FormConfirmation.css";

export const FormConfirmation = ({
  error,
  success,
}: {
  error?: { message: string };
  success?: { message: string };
}) => {
  return (
    <div className={styles.root}>
      <CardTextRadio
        theme={error ? "negative" : success ? "positive" : undefined}
        selected={true}
        className={styles.card}
      >
        <div className={styles.text}>
          <Paragraph size="Sm">{error?.message || success?.message}</Paragraph>
        </div>
      </CardTextRadio>
    </div>
  );
};
